import React from 'react';
import PropTypes from 'prop-types';

const StoreMessage = ({ storeApiMessaging }) => (
  storeApiMessaging.length === 0 ? null
    : (
      <div className="single-store__messaging">
        {storeApiMessaging.map((message) => <p key={message.key}>{message.value}</p>)}
      </div>
    )
);

StoreMessage.propTypes = {
  storeApiMessaging: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
};

export default StoreMessage;
